import { restApiClient } from '@/datasources';
import { CartCouponForcedRemoval } from '@/types/cart.types';

export const REMOVE_CART_ITEMS_ROUTE = '/online/cart/bulk-delete-cart-items';

export async function removeCartItems(cartItemsIds: string[]): Promise<CartCouponForcedRemoval> {
  const { data } = await restApiClient.post<CartCouponForcedRemoval | undefined>(
    REMOVE_CART_ITEMS_ROUTE,
    { cartItemsIds },
  );

  return data ?? { removedCouponForced: false };
}
